import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import QRCode from 'qrcode';
import { Box, MONO, Skeleton, Stack, Typography } from '@platform/design-system';
/**
 * The enrolment half of TOTP: a QR code (an `<img>` with alt text — never markup injected from
 * a string) and the secret in mono for people who type it. The code field belongs to the
 * form around it, so the same panel serves the sign-in challenge and account settings.
 */
export function TotpSetupPanel({ secret, uri }) {
    const [dataUrl, setDataUrl] = useState(null);
    const [failed, setFailed] = useState(false);
    useEffect(() => {
        let cancelled = false;
        QRCode.toDataURL(uri, { margin: 1, width: 176, errorCorrectionLevel: 'M' })
            .then((url) => {
            if (!cancelled)
                setDataUrl(url);
        })
            .catch(() => {
            if (!cancelled)
                setFailed(true);
        });
        return () => {
            cancelled = true;
        };
    }, [uri]);
    return (_jsxs(Stack, { spacing: 2, children: [_jsx(Typography, { variant: "body2", color: "text.secondary", children: "Scan this with an authenticator app (any that supports time-based codes), or type the key in by hand." }), _jsx(Box, { sx: {
                    display: 'flex',
                    justifyContent: 'center',
                    p: 1.5,
                    bgcolor: 'background.subtle',
                    border: 1,
                    borderColor: 'hairline',
                    borderRadius: 2,
                }, children: dataUrl ? (_jsx("img", { src: dataUrl, width: 176, height: 176, alt: "QR code for your authenticator app", style: { display: 'block', borderRadius: 6 } })) : failed ? (_jsx(Typography, { variant: "caption", color: "text.tertiary", children: "The QR code could not be drawn here \u2014 enter the key below instead." })) : (_jsx(Skeleton, { variant: "rectangular", width: 176, height: 176 })) }), _jsxs(Stack, { spacing: 0.5, children: [_jsx(Typography, { variant: "caption", color: "text.secondary", component: "span", children: "Setup key" }), _jsx(Typography, { component: "code", sx: { ...MONO, wordBreak: 'break-all', userSelect: 'all' }, children: groupSecret(secret) })] })] }));
}
/** `JBSWY3DPEHPK3PXP` → `JBSW Y3DP EHPK 3PXP` for reading aloud or typing. */
export function groupSecret(secret) {
    return secret
        .replace(/\s+/g, '')
        .replace(/(.{4})/g, '$1 ')
        .trim();
}
//# sourceMappingURL=totp-setup-panel.js.map